import React from "react";
import MenuApi from "../Data/HomePage/Menu";

function MenuScrollNav() {
  return (
    <>
      <div>
        <ul className="menu scroll-nav d-flex">
          {MenuApi.map((value) => {
            return (
              <>
                <li key={value.id}>
                  <a className="scroll-to" href={`#${value.linkHref}`}>
                    <span>{value.name}</span> <i className={value.icon}></i>
                  </a>
                </li>
              </>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export default MenuScrollNav;
